import { Product } from 'screens/Applications&WorkOrders/StepsLayout/Constants/formikData';
import { ProductInventoryItem } from '../components/FillProductDetailsDrawer/types';
import { DEFAULT_QUANTITY_MODE } from '../components/FillProductDetailsDrawer/constants';
import { generateProductApplicationId } from './generateProductApplicationId';

// eslint-disable-next-line import/prefer-default-export
export const formatProductsToApplication = (
  items: ProductInventoryItem[]
): Product[] => {
  return (items || []).map(item => ({
    id: item.id || item.productId,
    productApplicationId: generateProductApplicationId(item.productId),
    name: item.name || item.productName,
    manufacturer: item.manufacturer || item.manufacturerName,
    productType: item.producttype || item.productType,
    isInUse: true,
    quantityMode: DEFAULT_QUANTITY_MODE,

    // TOTALS - empty by default, will be filled by user
    ratePerAcre: '',
    ratePerAreaUnit: item.stdunit || item.stdUnit || '',
    totalProduct: '',
    totalProductUnit: item.stdpackageunit || item.stdPackageUnit || '',
    ratePerTank: '',
    ratePerTankUnit: item.stdunit || item.stdUnit || '',

    // PRICES
    priceValue: item.averagePricePerUnit || 0,
    priceUnit:
      item.averagePricePerUnitUnit ||
      item.stdpackageunit ||
      item.stdPackageUnit ||
      '',
    saveAsNewListPrice: false,

    // PRICE REFERENCES
    averagePricePerUnit: item.averagePricePerUnit,
    averagePricePerUnitUnit:
      item.averagePricePerUnitUnit ??
      item.stdpackageunit ??
      item.stdPackageUnit ??
      '',

    // AREA
    totalArea: 0, // will be updated from application values
    totalAppliedAcreage: 0, // will be updated from application values
    appliedAreaValue: 0, // will be updated from application values
    coveragePercent: 100,

    // OTHER
    applicationMethod: undefined, // undefined = drawer will use application-level value
    targetPests: [],
    registrationNumber:
      item.registrationNumber || item.registrationnumber || '',
    custom: item.custom || false,
    isCarrier: false,
    isHidden: false,

    // CALCULATIONS
    // I kept the lowercase version cause the in place methods for calculations are expecting lowercase
    // check: calculateProductValues in src/helpers/unitConversionHelpers.js
    density: item.productDensity || item.density || 1,
    stdpackageunit: item.stdpackageunit || item.stdPackageUnit || '',
    stdfactor: item.stdfactor || item.stdFactor || 1,
    stdunit: item.stdunit || item.stdUnit || ''
  }));
};
